import { useEffect } from 'react'

export function PracticeModeBar() {
  useEffect(() => {
    window.oneApp?.postMessage('hasOwnExit')
  }, [])

  return (
    <div
      data-practice-bar
      className="w-full flex items-end bg-[#1f2937] shrink-0 z-[110]"
      style={{
        paddingTop: 'max(44px, env(safe-area-inset-top, 0px))',
        height: 'calc(max(44px, env(safe-area-inset-top, 0px)) + 40px)',
      }}
    >
      <div className="flex w-full items-center gap-2 px-4 pb-2.5">
        <span className="size-2 shrink-0 rounded-full bg-orange-500" aria-hidden="true" />
        <span className="text-xs font-bold uppercase tracking-wide text-orange-500">
          Practice Mode
        </span>
        <span className="text-xs text-gray-400">Nothing here is real</span>
        <div className="flex-1" />
        <button
          type="button"
          className="text-sm font-medium text-white active:opacity-70"
          onClick={() => window.oneApp?.postMessage('exitWebView')}
        >
          Exit
        </button>
      </div>
    </div>
  )
}
